import axios from 'axios';
import { attachAuthToken } from './authToken';

const instance = axios.create();

attachAuthToken(instance);

export default instance;
